/* JP Racing — Model + Category filter groups for the collection sidebar.
   Injects "Model" and "Category" link groups (backed by collections) at the
   top of Dawn's vertical facets sidebar + mobile filter drawer, and hides
   the Availability facet (everything is sell-when-out-of-stock at JP).
   Self-guarded to collection pages; re-applies after Dawn re-renders facets. */
(function () {
  if (!/^\/collections\//.test(window.location.pathname)) return;

  var GROUPS = [
    { heading: 'Model', items: [
      { label: 'All Models', handle: 'all' },
      { label: 'Sea-Doo 300', handle: 'sea-doo-300' },
      { label: 'Sea-Doo 325 / 350', handle: 'sea-doo-325-350' },
      { label: 'Sea-Doo 215 / 230 / 255 / 260', handle: 'sea-doo-legacy' },
      { label: 'Yamaha SVHO', handle: 'yamaha-svho' },
      { label: 'Yamaha SHO', handle: 'yamaha-sho' }
    ]},
    { heading: 'Category', items: [
      { label: 'Performance Upgrades', handle: 'performance-upgrades' },
      { label: 'Supercharger Upgrades', handle: 'supercharger-upgrades' },
      { label: 'Intercooler Upgrades', handle: 'intercooler-upgrades' },
      { label: 'Intake', handle: 'intake' },
      { label: 'Exhaust', handle: 'exhaust' },
      { label: 'Engine Upgrades', handle: 'engine-upgrades' },
      { label: 'Tuning', handle: 'tuning' },
      { label: 'Jet Pump Parts', handle: 'jet-pump-parts' },
      { label: 'OEM Parts', handle: 'oem-parts' },
      { label: 'Tools', handle: 'tools' },
      { label: 'Apparel and Trinkets', handle: 'apparel' }
    ]}
  ];

  var CSS = [
    '.jp-model-filter{border-bottom:.1rem solid rgba(18,18,18,.12);padding:0 0 1.6rem;margin:0 0 1.6rem;}',
    '.jp-model-filter__heading{font-family:"Barlow Condensed",sans-serif;font-size:1.8rem;font-weight:700;letter-spacing:.05rem;text-transform:uppercase;color:#121212;margin:0 0 .8rem;}',
    '.jp-model-filter__list{list-style:none;margin:0;padding:0;}',
    '.jp-model-filter__link{display:block;padding:.55rem 0;font-size:1.5rem;line-height:1.3;color:rgba(18,18,18,.85);text-decoration:none;}',
    '.jp-model-filter__link:hover{color:#E10600;text-decoration:underline;}',
    '.jp-model-filter__link.jp-active{color:#E10600;font-weight:700;}',
    '.jp-model-filter__count{color:rgba(18,18,18,.5);font-size:1.3rem;}'
  ].join('');

  function styleOnce() {
    if (document.getElementById('jp-model-filter-style')) return;
    var s = document.createElement('style');
    s.id = 'jp-model-filter-style';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function hideAvailability() {
    // Structural match: the Availability group's inputs are named filter.v.availability.
    document.querySelectorAll('input[name="filter.v.availability"]').forEach(function (inp) {
      var box = inp.closest('details') || inp.closest('[class*="facets__"]');
      if (box) box.style.display = 'none';
    });
    // Fallback: any facet group whose summary label reads "Availability".
    document.querySelectorAll('details').forEach(function (d) {
      var s = d.querySelector('summary');
      if (s && s.textContent.trim().toLowerCase().indexOf('availability') === 0) {
        d.style.display = 'none';
      }
    });
    // Hide Dawn's "Filter:" sidebar label so MODEL reads as the top sidebar heading.
    document.querySelectorAll('.facets__heading').forEach(function (h) {
      if (h.textContent.trim().toLowerCase() === 'filter:') h.style.display = 'none';
    });
  }

  function buildGroup(group) {
    var cur = window.location.pathname.replace(/\/$/, '');
    var div = document.createElement('div');
    div.className = 'jp-model-filter';
    var html = '<h3 class="jp-model-filter__heading">' + group.heading + '</h3><ul class="jp-model-filter__list">';
    group.items.forEach(function (m) {
      var href = '/collections/' + m.handle;
      var active = cur === href;
      html += '<li><a class="jp-model-filter__link' + (active ? ' jp-active' : '') + '" href="' + href + '">' +
        m.label + ' <span class="jp-model-filter__count" data-jp-count="' + m.handle + '"></span></a></li>';
    });
    html += '</ul>';
    div.innerHTML = html;
    return div;
  }

  function buildAll() {
    var wrap = document.createElement('div');
    wrap.className = 'jp-sidebar-groups';
    GROUPS.forEach(function (g) { wrap.appendChild(buildGroup(g)); });
    return wrap;
  }

  var countsLoaded = false;
  function fillCounts() {
    if (countsLoaded) return;
    countsLoaded = true;
    var all = [];
    GROUPS.forEach(function (g) { g.items.forEach(function (m) { all.push(m); }); });
    all.forEach(function (m) {
      fetch('/collections/' + m.handle + '/products.json?limit=250')
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var n = (j.products || []).length;
          document.querySelectorAll('[data-jp-count="' + m.handle + '"]').forEach(function (el) {
            el.textContent = '(' + n + ')';
          });
        })
        .catch(function () {});
    });
  }

  function inject() {
    styleOnce();
    hideAvailability();
    var desk = document.querySelector('#FacetsWrapperDesktop');
    if (desk && !desk.querySelector('.jp-sidebar-groups')) {
      desk.insertBefore(buildAll(), desk.firstChild);
    }
    var mobForm = document.querySelector('#FacetFiltersFormMobile');
    if (mobForm && !mobForm.querySelector('.jp-sidebar-groups')) {
      mobForm.insertBefore(buildAll(), mobForm.firstChild);
    }
    if (desk || mobForm) fillCounts();
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; inject(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
  var mo = new MutationObserver(schedule);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
